/** Retain sheet IDs and filters when following links to removed production pages. */
export const getLegacyRouteSheetSearch = (
  params: URLSearchParams,
  source: 'in-progress' | 'quality-control',
) => {
  const next = new URLSearchParams(params)
  const hasAction =
    source === 'in-progress'
      ? params.has('assignSheet')
      : params.has('routeSheetId')
  const workTab = hasAction ? 'assignment' : 'work'
  next.set('tab', source === 'quality-control' ? 'qc' : workTab)
  if (hasAction) next.delete('focus')
  else next.set('focus', 'scan')
  return next.toString()
}
